import WaybillsTableColumnCar from './index.vue'
export default WaybillsTableColumnCar